/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.8.30",
    versionName: "0.2.0-nightly.2025.8.30",
    versionChannel: "nightly",
    buildDate: "2025-08-30T00:06:59.706Z",
    commitHash: "d08fa95382a4f4426968728130db62868b31f5c8",
};
